import React, { Component } from 'react';
import logo from 'static/img/logo-white.svg';
import './AppTvboard.css'
import {getRanking} from "../../api/internal/ranking.js";
import {getProgress} from "../../api/internal/progress.js";
import {getTotalNumbers} from "../../api/public/totalNumbers.js";
import {getDisciplines} from "../../api/public/disciplines.js";
import {getMonthName} from "../../Helpers.js";

import MonthCategoryStats from "./MonthStats/MonthCategoryStats";
import MonthSummaryStats from "./MonthStats/MonthSummaryStats";

import RankingList from '../bfmPanel/RankingList/RankingList.js';
import ProgressBonus from '../bfmPanel/ProgressBonus/ProgressBonus.js';
import { withNamespaces } from 'react-i18next';

class AppTvboard extends Component {
    constructor(props){
      super(props);
      this.state = {
        bfmStats: '',
        lang: localStorage.getItem('language') || 'en',
        ranking: [],
        rankingLoading: true,
        current_month: '',
        progress: {'currentPoints':0, 'pointsThreshold':1, 'payment': 0},
        period: 'current',
        categories: [],
        network_error : false
      };
    }
    renderNoInternet(t) {
      return <div className="Tvboard__network_fail">
        {t("TV_Network_error")}
      </div>
    }
    render() {
      const { t } = this.props;

      return (
        <div className="Tvboard">
          {this.state.network_error ? this.renderNoInternet(t) : null}
          <div className="Tvboard__layout">
            <div className="Tvboard__layout-head">
              <div className="Tvboard__layout-head_layout">
                <img className="Tvboard__layout-head-logo" src={logo} alt="Burn for Money" />
                <div className="Tvboard__layout-head-date" >
                  {this.state.current_month}
                </div>
              </div>
            </div>
            <div className="Tvboard__layout-board">
              <div className="Tvboard__layout-board__inner-layout">
                <div className="Tvboard__layout-board__summary">
                  <h4 className="Tvboard__layout-board__header">
                    {t("TV_Summary")}
                  </h4>
                  <div className="Tvboard__layout-board__summary-content">
                    <div className="Tvboard-ProgressBonus">
                      <ProgressBonus
                        progress={this.state.progress}
                        period={this.state.period}
                       />
                    </div>
                    <MonthSummaryStats data={this.state.bfmStats}/>
                  </div>
                </div>
                <div className="Tvboard__layout-board__category">
                  <h4 className="Tvboard__layout-board__header">
                    {t("TV_Result_per_category")}
                  </h4>
                  <div className="Tvboard__layout-board__category-content">
                    <MonthCategoryStats
                      data={this.state.bfmStats}
                      categories={this.state.categories}
                    /></div>
                  </div>
                <div className="Tvboard__layout-board__ranking">
                  <h4 className="Tvboard__layout-board__header">
                    {t("TV_TOP_10")}
                  </h4>
                  <div className="Tvboard__layout-board__ranking-content">
                    <RankingList ranking={this.state.ranking.slice(0, 10)} rankingLoading={this.state.rankingLoading} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    fetchStats(){
      const currentDate = new Date();
      this.setState({current_month: `${getMonthName(currentDate.getMonth())} ${currentDate.getFullYear()}`});

      getTotalNumbers()
        .then(
          (result) => {this.setState({ bfmStats: result}); },
          (error) => { console.error('[fetchStats] Error:', error); this.setState({network_error: true});}
        );

      getRanking(`?month=${currentDate.getMonth()+1}&year=${currentDate.getFullYear()}`)
        .then(
          (result) => {this.setState({ranking: result,  rankingLoading: false });},
          (error) => { console.error('[fetchStats] Error:', error); this.setState({network_error: true});}
        );
    }

    updateProgress = () => {
      const today = new Date();
      const todayYear = today.getFullYear();
      const todayMonth = today.getMonth()+1;

      getProgress(`?year=${todayYear}&month=${todayMonth}`)
        .then(
          (result) => {
            this.setState({pointsAndMoney: {'points': Math.floor(result.totalPoints), 'money': result.totalMoney}});
            this.setState({progress: {'currentPoints':Math.floor(result.currentPoints), 'pointsThreshold':Math.floor(result.pointsThreshold), 'payment': result.payment}});
          },
          (error) => {console.error('[updateProgress] Error:', error); this.setState({network_error: true});}
        );
    }

    getCategories = () => {
      getDisciplines()
        .then(
          (result) => {
            this.setState({categories: result });
            },
          (error) => { console.error('[getCategories] Error:', error); this.setState({network_error: true});}
        );
    }

    updateWholePage = () => {
      this.setState({network_error: false});
      this.getCategories();
      this.fetchStats();
      this.updateProgress();
    }

    componentDidMount(){
      this.updateWholePage();
      this.fetch_timer = setInterval(() => this.updateWholePage(), 5000*60);
    }

    componentWillUnmount(){
      clearInterval(this.fetch_timer);
    }
}

export default withNamespaces()(AppTvboard);



// WEBPACK FOOTER //
// ./src/screens/tvboard/AppTvboard.js